// Dev-only shim to prevent “process is not defined” inside Mapbox worker when using CDN.
// We override workerClass with a tiny wrapper that defines self.process before loading the CSP worker.
if (
  process.env.NODE_ENV === 'development' &&
  typeof window !== 'undefined' &&
  typeof window.mapboxgl !== 'undefined' &&
  typeof window.Worker !== 'undefined'
) {
  try {
    const workerUrl =
      'https://api.mapbox.com/mapbox-gl-js/v2.14.1/mapbox-gl-csp-worker.js';
    window.mapboxgl.workerClass = class extends Worker {
      constructor() {
        const blob = new Blob(
          [
            'self.process = self.process || { env: { NODE_ENV: "development" } };',
            `importScripts("${workerUrl}");`,
          ],
          { type: 'text/javascript' },
        );
        const url = URL.createObjectURL(blob);
        super(url);
        URL.revokeObjectURL(url);
      }
    };
  } catch (err) {
    // dev-only shim; fail silently
    // console.error('[mapboxWorkerDevShim] failed', err);
  }
}
